// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"dbdd3437","5908":"4f936c60","7684":"276ac88e","7850":"a80813a9","8272":"53978d44"}[chunkId] + ".chunk.css";
};